import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";
import { ALL_LEVELS, type JourneyLevel } from "../delight";
import { cn } from "@/lib/utils";

/**
 * Level, not percentage. Five ranks across the walk, shown as filled stars
 * with the rank name beside them. Purely presentational — see delight.ts.
 */
export function LevelBadge({ level, className }: { level: JourneyLevel; className?: string }) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-3 py-1",
        className,
      )}
    >
      <span className="flex items-center gap-0.5" aria-hidden>
        {ALL_LEVELS.map((l) => (
          <Star
            key={l.rank}
            className={cn(
              "h-3 w-3 transition-colors",
              l.rank <= level.rank ? "text-primary fill-primary" : "text-border",
            )}
          />
        ))}
      </span>
      <AnimatePresence mode="wait">
        <motion.span
          key={level.name}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.25 }}
          className="text-xs font-medium text-primary whitespace-nowrap"
        >
          {level.name}
        </motion.span>
      </AnimatePresence>
      <span className="sr-only">
        Level {level.rank} of {ALL_LEVELS.length}: {level.name}
      </span>
    </div>
  );
}
